let header = document.querySelector("header");
let navbarDesk = header.querySelector(".nav-desktop");
let navbarMobile = header.querySelector(".nav-mobile");
let navDrop = header.querySelector(".nav-drop");
let hamburger = header.querySelector(".ham");
let navCloseBtn = header.querySelector(".nav-close");
/////////////// Drop down
let dropDown = navbarDesk.dataset.style;
if (header.classList.contains("sticky-header")) {
  header.closest(".shopify-section").classList.add("header-sticky-header");
  header.closest(".shopify-section").style.backgroundColor =
    header.style.backgroundColor;
}

if (dropDown == "nested") {
  navbarDesk.querySelectorAll("li").forEach(function (el, ind) {
    let drop = el.querySelector(".nested-item");
    el.addEventListener("mouseenter", function () {
      drop?.classList.add("visible");
    });
    el.addEventListener("mouseleave", function () {
      drop?.classList.remove("visible");
    });
  });
} else {
  navbarDesk
    .querySelector("ul")
    .querySelectorAll("li")
    .forEach(function (el, ind) {
      let drop = el.querySelector(".level-1");
      el.addEventListener("mouseenter", function () {
        drop?.classList.add("visible");
      });
      el.addEventListener("mouseleave", function () {
        drop?.classList.remove("visible");
      });
    });
}
/////////////////////Mobile nav
navbarMobile.querySelectorAll("li").forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.stopPropagation();
    let url = el.querySelector("a").getAttribute("href");
    if(url == null){
      e.preventDefault();
    }
    el.classList.add("visible");
  });
});
navbarMobile.querySelectorAll(".prev-nav").forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    let li = el.closest(".visible");
    if (!li) return;
    li.classList.remove("visible");
  });
});
const toggleNav = () => {
  navbarMobile.classList.toggle("show");
  navDrop.classList.toggle("show");
};
hamburger.addEventListener("click", toggleNav);
navCloseBtn.addEventListener("click", toggleNav);
navDrop.addEventListener("click", toggleNav);
